<template>
    <div class="inner-empty">
        <slot></slot>
        <div class="data" v-if="brand_name" :key="key_re">
            <img :src="left_img" alt="img">
            <div class="gray">
                <div class="title">{{ list.title }}</div>
                <div class="desc">{{ list.desc }}</div>
                
                <div class="item" v-for="(v, k) in list.content" :key="k">
                    <svg-icon name="arrow-2" />
                    <div class="text">
                        <div class="tit">{{ v.tit }}</div>
                        <div class="des-small">{{ v.desc }}</div>
                    </div>
                </div>
                <Alert v-if="!can_add" svgName="lock" className="yellow">
                    <p>Your Anchor plan does not include the Recruitment dashboard.
                        <!-- <router-link :to="'/help'"> Contact us to upgrade</router-link> -->
                        <a :href="mail_content" target="_blank"> Contact us to upgrade</a>
                    </p>
                </Alert>
                <div class="btn-box">
                    <Button v-if="had_programs" size="32" color="dark-blue" :border_r="6" @click="addApp">
                        {{ btnText }}
                    </Button>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/ui/Button.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Alert from '@/components/settings/SettingAlert.vue';

export default {
    name: 'AppEmptyList',

    data() {
        return {
            left_img: require('@/assets/images/Program_Empty.png'),
            list: {
                title: 'Anchor Your Growth: Streamline Partnerships With The Recruitment Dashboard',
                desc: `Introducing Anchor's partnership Recruitment dashboard, where you can capture inbound requests for collaboration, collect all the information you need from prospective ambassadors, and scale your storefront program with ease.`,
                content: [
                    { tit: 'Empower Authentic Endorsements', desc: `With the Recruitment dashboard unlocked, your brand receives a landing page to direct incoming requests for partnership, so you can equip influencers, creators, students, and/or employees who truly love what you do with a custom storefront experience.` },
                    { tit: 'Easily Scale Creator Storefronts', desc: `Go from "I'd love to work with ${this.brand_name}" to "Shop my custom ${this.brand_name} storefront" in an instant. Simply approve an application and the ambassador instantly receives an invitation to launch their personalized storefront.` },
                    { tit: 'Centralize Ambassador Information', desc: `Gain a more holistic view of your potential ambassadors. Evaluate everyone who wants to work with your brand in one place, with all the details you need to make strategic decisions on how to activate.` },
                    { tit: 'Save Bandwidth With Automatic Review', desc: `Want to instantly approve or deny requests for partnership based on specific fields? Done! Set fields like follower-counts or location as deal-breakers or deal-makers to send automated responses to your applicants.` },
                    { tit: `Tailor To Fit Your Brand's Needs`, desc: `We provide you with default templates that capture the basic information we think you'll need based on your program type, while leaving room for all the customizations you'll want.` },
                ]
            },
            mail_content: `mailto:anchor@motom.me?subject=${this.$store.state.user_data ? this.$store.state.user_data.merchant_account.merchant_display_name : ''} - Upgrade to Custom Subdomain&body=Please provide your name and contact info. A representative will contact you in 1-2 business days.`,
            key_re:0,

        }
    },

    props: {
        is_app: {
            type: Boolean,
            default: true,
        },
        had_programs: {
            type: Boolean,
            default: true,

        },
    },

    components: {
        Button,
        Scrollbar,
        Alert,
    },

    watch: {
        brand_name(val) {
            console.log(val);
            if (val) {
                this.mail_content = `mailto:anchor@motom.me?subject=${val} - Upgrade to Custom Subdomain&body=Please provide your name and contact info. A representative will contact you in 1-2 business days.`;
                this.list.content[1].desc= `Go from "I'd love to work with ${val}" to "Shop my custom ${val} storefront" in an instant. Simply approve an application and the ambassador instantly receives an invitation to launch their personalized storefront.`;
                this.key_re+=1;
            }
        }
    },

    computed: {
        can_add(){
            let user_d=this.$store.state.user_data;
            return user_d && user_d.merchant_account && user_d.merchant_account.is_enable_ambassador_program;
        },
        btnText() {
            return this.can_add ? 'Create Program' : 'Contact';
        },

        brand_name() {
            return this.$store.state.user_data?this.$store.state.user_data.merchant_account.merchant_display_name:'';
        },
    },

    methods: {
        openEmail() {
            window.location.href = this.mail_content;
            // this.$router.push('/help');
        },
        addApp() {
            if (this.can_add) {
                this.$emit('create');
            } else {
                this.openEmail();
            }
        },
    },

    mounted(){
        this.list.content[1].desc= this.list.content[1].desc= `Go from "I'd love to work with ${this.brand_name}" to "Shop my custom ${this.brand_name} storefront" in an instant. Simply approve an application and the ambassador instantly receives an invitation to launch their personalized storefront.`;
        this.key_re+=1;
    }
}
</script>
<style lang="scss">
.inner-empty {
    padding: 24px 32px 24px 48px;
    background: var(--white);
    border-radius: 16px 0 0 0;
    min-width: 970px;
    .data {
        display: grid;
        grid-template-columns: 350px 1fr;
        margin: 16px 0;
        width: 100%;
        border-radius: 6px;
        overflow: hidden;

        img {
            height: 100%;
            object-fit: cover;
            width: 100%;
            min-width: 350px;
            object-position: left;
        }

        .gray {
            background-color: var(--bg-02);
            padding: 24px;

            .title {
                font: var(--font-med-30);
            }

            .scrollbar-content {
                height: calc(100vh - 420px);
            }

            .desc {
                font-size: 14px;
                margin: 16px 0;
            }

            .item {
                display: grid;
                grid-template-columns: 22px 1fr;
                align-items: flex-start;
                gap: 6px;
                margin-bottom: 12px;

                .svg-icon {
                    width: 22px;
                    height: 18px;
                    margin-top: 6px;
                    margin-right: 6px;
                }

                .text {
                    padding: unset !important;
                    .tit {
                        font: var(--font-med-16);
                    }

                    .des-small {
                        font-size: 12px;
                    }
                }
            }

            .btn-box {
                width: 100%;

                .ui-button {
                    float: right;
                }
            }

        }
    }

}
</style>